// extracted by mini-css-extract-plugin
export default {"spinner":"PublicPages_spinner__ldyMr","spin":"PublicPages_spin__3XCHI"};